import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

export const useAnalytics = (data: Record<string, string | number>) => {
  useEffect(() => {
    if (Object.keys(data).length > 0) {
      Object.keys(data).forEach(key => {
        datadogRum.setGlobalContextProperty(key, data[key]);
      });
    }

    return () => {
      Object.keys(data).forEach(key => {
        datadogRum.removeGlobalContextProperty(key);
      });
    };
  }, [data]);
};
